import { useMemo } from 'react';
import { LayoutType } from '../../enums';
import { CustomLayoutProps } from '../../interfaces';
import DefaultLayout from './Default';
import ContentOnlyLayout from './ContentOnly';
import './styles.scss';
import MobileLayout from './Mobile';

const CustomLayout: React.FC<CustomLayoutProps> = props => {
  const {
    type = LayoutType.DEFAULT,
    margin = 0,
    padding = 0,
    style = {},
    sider,
    ...rest
  } = props;

  const Component = useMemo(() => {
    switch (type) {
      case LayoutType.CONTENT_ONLY:
        return ContentOnlyLayout;
      case LayoutType.MOBILE:
        return MobileLayout;
      default:
        return DefaultLayout;
    }
  }, [type]);

  return (
    <Component {...rest} sider={sider} style={{ ...style, padding, margin }} />
  );
};

export default CustomLayout;
